import { EnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { environment } from '../../../environments/environment';
import { metaReducers, reducers } from './index';
import { PaymentEffects } from './payment/payment.effects';
import * as fromPayment from './payment/payment.reducer';
import { RiderAuthenticationEffects } from './rider-authentication/rider-authentication.effects';
import * as fromRiderAuthentication from './rider-authentication/rider-authentication.reducer';
import { RidesEffects } from './rides/rides.effects';
import * as fromRides from './rides/rides.reducer';

export function provideRideWssStore(): Array<EnvironmentProviders> {
  return [
    provideStore(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionWithinNgZone: true
      }
    }),
    provideEffects([]),
    provideState(fromPayment.paymentFeatureKey, fromPayment.reducer),
    provideState(fromRides.ridesFeatureKey, fromRides.reducer),
    provideState(fromRiderAuthentication.riderAuthenticationFeatureKey, fromRiderAuthentication.reducer),
    provideEffects(RidesEffects, PaymentEffects, RiderAuthenticationEffects),
    provideStoreDevtools({
      maxAge: 250,
      logOnly: environment.production,
      autoPause: true
    })
  ];
}
